import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { DateType } from '../interfaces/common.interface';
import { LuxonHelpersService } from '../services/luxon-helpers.service';

@Pipe({
  name: 'toLuxon',
  standalone: true,
})
export class ToLuxonPipe implements PipeTransform {
  private _luxonHelpersService = inject(LuxonHelpersService);
  transform(
    date: string,
    timezone = 'local',
    dateType = DateType.SQL
  ): DateTime {
    return this._luxonHelpersService.getLuxonDate(date, timezone, dateType);
  }
}
